import { Component, Inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, LoopBackAuth, VehicleService, VehicleServiceApi } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';
import { HelperService } from '../../services/helper.service';
import { ExtLoopBackAuth } from 'src/app/shared/modules/ext-sdk/services/ext-sdk-auth.service';

@Component({
  selector: 'app-vehicle-service-details-tab-service-states',
  templateUrl: './vehicle-service-details-tab-service-states.component.html',
  styleUrls: ['./vehicle-service-details-tab-service-states.component.scss'],
  providers: [],
})
export class VehicleDetailsTabServiceStatesComponent extends ABaseComponent {
  _vehicleService: VehicleService;

  @Input()
  set vehicleService(v: VehicleService) {
    this._vehicleService = v;
    this.changeHandle();
  }
  get vehicleService() {
    return this._vehicleService;
  }

  dso: DataSourceOptions;

  constructor(
    protected logger: LoggerService,
    protected ui: UiService,
    protected dss: DataSourceService,
    protected dialog: MatDialog,
    public helperService: HelperService,
    @Inject(LoopBackAuth) private auth: ExtLoopBackAuth,
  ) {
    super(logger);
  }

  changeHandle() {}

  async onServiceStateInserting(event: any): Promise<void> {
    try {
      event.data.id = event.data.__KEY__;
      event.data.createdAt = new Date();
      const { id, username } = this.auth.getCurrentUserData();
      event.data.createdBy = { id, username };

      let { serviceStates } = this.vehicleService;
      serviceStates = [{ ...event.data, __KEY__: undefined }, ...this.vehicleService.serviceStates];
      this.vehicleService.serviceStates = serviceStates; // Update the local state with predicted data

      // Call the API to add the new service state
      const updatedVehicleService = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { serviceStates })
        .toPromise();

      // Update the local state with the response
      this.vehicleService.serviceStates = updatedVehicleService.serviceStates;
    } catch (error) {
      notify('Error inserting service state', 'error', 3000);
      console.error('Error inserting service state:', error);
      event.cancel = true;
    }
  }

  async onServiceStateUpdating(event: any): Promise<void> {
    try {
      const { serviceStates } = this.vehicleService;
      const index = serviceStates.findIndex((state: any) => state.id === event.key.id);
      if (index !== -1) {
        serviceStates[index] = { ...serviceStates[index], ...event.newData, updatedAt: new Date() };
        const { serviceStates: updatedServiceStates } = await this.dss
          .getApi<VehicleServiceApi>(VehicleService)
          .mySaveWithRelated(this.vehicleService.id, { serviceStates })
          .toPromise();
        this.vehicleService.serviceStates = updatedServiceStates;
      }
    } catch (error) {
      notify('Error updating service state', 'error', 3000);
      console.error('Error updating service state:', error);
      event.cancel = true;
    }
  }

  async onServiceStateRemoving(event: any): Promise<void> {
    const { serviceStates } = this.vehicleService;
    const index = serviceStates.findIndex((state: any) => state.id === event.key.id);
    if (index !== -1) {
      serviceStates.splice(index, 1);
      const { serviceStates: updatedServiceStates } = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { serviceStates })
        .toPromise();
      this.vehicleService.serviceStates = updatedServiceStates;
    }
  }
}
